@import "../../../../node_modules/@genexus/gemini/dist/gemini/globals/mixins.scss";

/*******************************
HOST / GENERAL
********************************/
:host {
  --gx-ide-container-elements-spacing: var(--spacing-gap-m);
  display: block;
  height: 100%;
  box-sizing: border-box;
}
.container {
  display: grid;
  height: 100%;
  grid-template-rows: auto 1fr auto;
  box-sizing: border-box;
}
.heading,
.content,
.footer,
.footer-above {
  padding: var(--gx-ide-container__padding);
}
/*PADDING*/
.container--padding-s {
  --gx-ide-container__padding: var(--spacing-padding-m);
}
.container--padding-m {
  --gx-ide-container__padding: var(--spacing-padding-l);
}
.container--padding-l {
  --gx-ide-container__padding: var(--spacing-padding-xl);
}
/*BORDERS*/
.container--display-border {
  border: 1px solid var(--gx-ide-container-border-color);
}
.container--display-border-top {
  border-top: 1px solid var(--gx-ide-container-border-color);
}
.container--display-border-end {
  border-inline-end: 1px solid var(--gx-ide-container-border-color);
}
.container--display-border-bottom {
  border-bottom: 1px solid var(--gx-ide-container-border-color);
}
.container--display-border-start {
  border-inline-start: 1px solid var(--gx-ide-container-border-color);
}
.container--overflow-hidden-y {
  overflow-y: hidden;
}
/*******************************
HEADING
********************************/
.heading {
  // @include gxg-flex-justify();
  display: flex;
  flex-direction: column;
  gap: var(--gx-ide-container__padding);
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid var(--gx-ide-container-border-color);
  &--no-border {
    border-bottom: 0;
  }
  &--no-padding {
    padding: 0;
  }
  &--no-padding-block-end {
    padding-block-end: 0;
  }
  &--no-gap {
    gap: 0;
  }
  &--inactive {
    color: var(--gxg-color--disabled);
  }
  &--padding-top {
    padding: var(--gx-ide-container__padding) 0 0 0;
  }
  &--slimmer {
    padding-top: var(--spacing-padding-m);
    padding-bottom: var(--spacing-padding-m);
  }
  &--form-text-height {
    .heading__title {
      min-height: var(--gxg-form-text-height);
      justify-content: center;
    }
  }
  &--flex-row {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}
/*******************************
CONTENT
********************************/
.content {
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-l);
  box-sizing: border-box;
  @include gxg-scrollbar();

  &--no-padding {
    padding: 0;
  }
  &--no-border-top {
    border-top: none;
  }
  &--flex {
    display: flex;
  }
  &--no-gap {
    gap: 0;
  }
  &--align-items-start {
    align-items: start;
  }
  &--align-items-center {
    align-items: center;
  }
  &--align-items-end {
    align-items: end;
  }
  &--justify-content-start {
    justify-content: start;
  }
  &--justify-content-center {
    justify-content: center;
  }
  &--justify-content-end {
    justify-content: end;
  }
  &--border-end {
    border-inline-end: 1px solid var(--gx-ide-container-border-color);
  }
}
/*only content*/
.container--only-content {
  grid-template-rows: 1fr;
}
/*no header, but has footer*/
.container--no-header:not(.container--only-content) {
  grid-template-rows: 1fr auto;
}
/*no footer, but has header*/
.container--no-footer:not(.container--only-content) {
  grid-template-rows: auto 1fr;
}
/*******************************
FOOTER
********************************/
/*ABOVE*/
.footer-above {
  border-top: 1px solid var(--gx-ide-container-border-color);
  &--no-border-top {
    border-top: 0;
  }
  &--slimmer {
    padding-top: var(--spacing-padding-m);
    padding-bottom: var(--spacing-padding-m);
  }
  &--no-padding {
    padding: 0;
  }
}
/*START and END*/
.footer {
  display: flex;
  gap: var(--gx-ide-container-elements-spacing);
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--gx-ide-container-border-color);
  &__start,
  &__end {
    display: flex;
    gap: var(--gx-ide-container-elements-spacing);
  }
  &--no-border {
    border-top: 0;
  }
  &--no-padding {
    padding: 0;
  }
  &--slimmer {
    padding-top: var(--spacing-padding-m);
    padding-bottom: var(--spacing-padding-m);
  }
}
